import styled, { DefaultTheme, css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export type StyledCategoryCardProps = {
  image?: string;
  height?: number;
};

const getCommonStyles = (theme: DefaultTheme, isCentered?: boolean) => {
  const { Color, Animation } = theme.Components.Skeleton;

  return `
  width: 100%;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${isCentered ? 'center' : 'flex-start'};
  gap: ${utils.rem(theme.Spacing.Size.XSmall)};
  .ant-skeleton > *:is(.ant-skeleton-input,.ant-skeleton-image) {
    background: linear-gradient(90deg,
      ${Color.Dark} ${Animation.Gradient.Start}%,
      ${Color.Light} ${Animation.Gradient.Center}%,
      ${Color.Dark} ${Animation.Gradient.End}%);
    background-size: ${Animation.Background}% 100%;
  }
`;
};

export const StyledCategoryCard = styled.div<{
  isCentered?: boolean;
}>`
  ${({ theme, isCentered }) => {
    return css`
      ${getCommonStyles(theme, isCentered)};
    `;
  }}
`;

export const StyledCategoryCardClickable = styled.a<{
  isCentered?: boolean;
}>`
  ${({ theme, isCentered }) => {
    return css`
      ${getCommonStyles(theme, isCentered)};
    `;
  }}
`;

export const StyledCategorySkeletonImage = styled.div<StyledCategoryCardProps>`
  width: 100%;
  & .ant-skeleton {
    width: 100%;
    .ant-skeleton-image {
      width: 100%;
      ${({ height }) => height && `height: ${utils.rem(height)};`}
    }
  }
`;

export const StyledCategorySkeletonText = styled.div<StyledCategoryCardProps>`
  ${({ theme }) => {
    const resultHeight = utils.rem(theme.Spacing.Size.MediumSmall);

    return `
      width: 100%;
      & .ant-skeleton .ant-skeleton-input {
        height: ${resultHeight};
      }
    `;
  }}
`;
